import * as constants from './constants';
import http from '../../../utils/request';

const getHomeData = (result) => ({
  type: constants.GET_HOME_DATA,
  head: result.head,
  record: result.record,
  doctor: result.doctor,
  achieve: result.achieve,
  cases: result.cases,
  product: result.product,
  partner: result.partner
});

export const fetchHomePageData = () => {
  return (dispatch) => {

    http('post', '/achieve/circle').then((res) => {
      const result = res.data;
      // console.log('result',result)
      dispatch(getHomeData(result));
    })
    
  }
}